<template>
    <!--
  Tailwind UI components require Tailwind CSS v1.8 and the @tailwindcss/ui plugin.
  Read the documentation to get started: https://tailwindui.com/documentation
-->
    <div class="container mx-auto transform sm:rounded-lg bg-gradient-to-r from-primary-500 to-primary-700">
        <div class="max-w-2xl px-4 py-16 sm:py-20 sm:px-6 lg:px-8">
            <h2 class="text-4xl font-extrabold leading-9 text-white sm:text-4xl sm:leading-10">
                <span class="block">Give Flowist a try today.</span>
            </h2>
            <p class="mt-4 text-xl leading-6 text-indigo-200">Invite your teammates and start collaborating!</p>
            <a
                href="https://beta.flowist.io/signup"
                class="inline-flex items-center justify-center w-full px-5 py-3 mt-8 text-base font-medium leading-6 transition duration-150 ease-in-out bg-white border border-transparent rounded-md text-primary-500 hover:text-indigo-500 hover:bg-indigo-50 sm:w-auto"
                >Start your 14 days free</a
            >
        </div>
    </div>
</template>

<script>
export default {
    name: 'app-footer-cta',
};
</script>

<style lang="scss" scoped></style>
